import { render, staticRenderFns } from "./TeamInfo.vue?vue&type=template&id=d2608c3c&"
import script from "./TeamInfo.vue?vue&type=script&lang=js&"
export * from "./TeamInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports